import {List, Col, Form, Input, Row, TimePicker, Upload, Button} from "antd";
import React from "react";
import {updateGeneral, updateWorkingHours} from "../../Store/Actions/shop";
// import moment from "moment";
import CustomMap from "../Map/Map";
import {Map} from "react-yandex-maps";
const timeFormat = 'HH:mm';
const { RangePicker } = TimePicker;
const rules = [{ required: true }];
const moment = require('moment-timezone');

class WorkingHours extends React.Component {

    state = {
        logoUrl: this.props.shop.logo,
        backgroundUrl: this.props.shop.background,
        logoList: [],
        backgroundList: [],
        uploading: false,
        current: 0,
    };

    onFinish = values => {
        this.setState({
            uploading: true
        });
        const { shop } = this.props;
        let hours = {};
        Object.entries(values.working_hours).forEach(day => {
            if(day[1]){
                hours[day[0]] = {
                    start: new Date(day[1][0]).getHours()*3600 + new Date(day[1][0]).getMinutes()*60,
                    end: new Date(day[1][1]).getHours()*3600 + new Date(day[1][1]).getMinutes()*60
                }
            } else {
                hours[day[0]] = {
                    start: shop.working_hours[day[0]].start,
                    end: shop.working_hours[day[0]].end
                }
            }
        });

        updateWorkingHours(shop.id, hours, res => {
            this.setState({
                uploading: false
            })
        })
    };


    render() {
        const { uploading, logoList, backgroundList, backgroundUrl, logoUrl, current } = this.state;
        const { shop } = this.props;


        return (
            <div>
                <Row gutter={8}>
                    <Col span={12}>
                        <div>
                            <div className="uk-margin-bottom">
                                <div>
                                    <h3 className="uk-h3 uk-margin-remove uk-text-bolder">
                                        Shop working hours
                                    </h3>
                                    <p className="uk-text-small uk-margin-remove">
                                        4 branches
                                    </p>
                                </div>
                            </div>

                            <div>
                                <Form onFinish={this.onFinish} layout="vertical" hideRequiredMark>
                                    <div>
                                        <div>
                                            {["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"].map(day => (
                                                <Row>
                                                    <Col span={6}>
                                                        <div>
                                                            <h6 className="uk-text-uppercase uk-margin-remove">
                                                                {day}
                                                            </h6>
                                                        </div>
                                                    </Col>
                                                    <Col span={18}>
                                                        <div>
                                                            <Form.Item initialValue={[moment.tz(new Date(shop.working_hours[day.substring(0, 3)].start*1000), timeFormat, "Africa/Abidjan"), moment.tz(new Date(shop.working_hours[day.substring(0, 3)].end*1000), timeFormat,"Africa/Abidjan")]} name={["working_hours", day.substring(0, 3)]}>
                                                                <RangePicker format={timeFormat} />
                                                            </Form.Item>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </div>
                                        <Form.Item>
                                            <Button disabled={uploading} loading={uploading} type="primary" size="large" htmlType="submit">
                                                Submit
                                            </Button>
                                        </Form.Item>
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </Col>
                    <Col span={12}>
                        <div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

}


export default WorkingHours;



// WEBPACK FOOTER //
// ./src/Components/Shop/Hours.js